import Kartawijaya1 from '../Tatar Kartawijaya/Kartawijaya (1).webp'
import Kartawijaya2 from '../Tatar Kartawijaya/Kartawijaya (2).webp'
import Kartawijaya3 from '../Tatar Kartawijaya/Kartawijaya (3).webp'
import Kartawijaya4 from '../Tatar Kartawijaya/Kartawijaya (4).webp'
import Kartawijaya5 from '../Tatar Kartawijaya/Kartawijaya (5).webp'
import Kartawijaya6 from '../Tatar Kartawijaya/Kartawijaya (6).webp'
import Kartawijaya7 from '../Tatar Kartawijaya/Kartawijaya (7).webp'
import Kartawijaya8 from '../Tatar Kartawijaya/Kartawijaya (8).webp'
import Kartawijaya9 from '../Tatar Kartawijaya/Kartawijaya (9).webp'
import Kartawijaya10 from '../Tatar Kartawijaya/Kartawijaya (10).webp'





const Kartawijayaimages =[
Kartawijaya1,Kartawijaya2,Kartawijaya3,Kartawijaya4,Kartawijaya5,Kartawijaya6,Kartawijaya7,Kartawijaya8,Kartawijaya9,Kartawijaya10
]

export default Kartawijayaimages;